// extracted by mini-css-extract-plugin
export default {"container":"styles__container___yCR5g","rightSidebar":"styles__rightSidebar___1g4d4","closeIcon":"styles__closeIcon___wPeh6"};